import React from 'react';

import { cn } from '~/lib/utils';

interface FancyUnderlineProps {
  children?: React.ReactNode;
  className?: string;
  textShadow?: boolean;
}

export function replaceAsteriskedTextWithFancyUnderline(text: string, textShadow?: boolean): React.ReactNode {
  const parts = text.split(/(\*[^*]+\*)/g); // Split by any flanked text using the asterisk
  return parts.map((part, index) => {
    if (part.startsWith('*') && part.endsWith('*')) {
      const content = part.slice(1, -1); // Remove the * characters
      return (
        <FancyUnderline key={index} textShadow={textShadow ?? true}>
          {content}
        </FancyUnderline>
      );
    }
    return part; // Return the non-flanked text as-is
  });
}

export function FancyUnderline({ children, className, textShadow = true }: FancyUnderlineProps) {
  return (
    <span className={cn('relative inline-block [font:inherit]', textShadow && 'text-shadow-[0_2px_white] ', className)}>
      {children}
      <ThickUnderline />
    </span>
  );
}

function ThickUnderline({ className }: { className?: string }) {
  return (
    <svg
      width='80'
      height='12'
      viewBox='0 0 80 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={cn('absolute inset-x-1 -bottom-1 -z-10 h-2 w-[calc(100%-.25rem)] lg:h-3', className)}
      preserveAspectRatio='none'
    >
      <path
        d='M3.41174 8.41724C16.1055 4.64412 48.5407 -0.638246 76.7321 8.41724'
        stroke='#FFDD00'
        strokeWidth='6'
        strokeLinecap='round'
      />
    </svg>
  );
}
